import { t } from '@formie/utils/utils.js';
import DefaultFormieValidator from '@formie/validator/validator.js';

/* Custom validator that patches some functions for compatibility */
class FormieValidator extends DefaultFormieValidator {
    constructor(form, config) {
        super(form, config);
    }

    getValidatorCallbackOptions(input) {
        const fieldContainer = input.closest('[data-field-handle]');

        if (!fieldContainer) {
            console.log(input);
            return;
        }

        const label = fieldContainer.dataset.fieldLabel; // this gets added from the site module's Field::EVENT_MODIFY_HTML_TAG listener

        return {
            t,
            input,
            label,
            field: fieldContainer,
            config: this.config,
            getRule: (rule) => {
                return this.getRule(fieldContainer, rule);
            },
        };
    }

    removeError(input) {
        input.removeAttribute('aria-errormessage');
        input.removeAttribute('aria-invalid');

        const fieldContainer = input.closest('[data-slot=field]');

        if (!fieldContainer) {
            return;
        }

        fieldContainer.dispatchEvent(
            new CustomEvent('formie:remove-error', {
                bubbles: false,
            })
        );

        this.emitEvent(input, 'formieValidatorClearError');
    }

    showError(input, validatorName, errorMessage) {
        const fieldContainer = input.closest('[data-field-handle]');

        if (!fieldContainer) {
            return;
        }

        // Create an error ID for this element, but saved to a cache, to ensure it's not generated every time
        const errorKey = `error-${fieldContainer.getAttribute('data-field-handle')}`;

        if (!this.errorIds[errorKey]) {
            this.errorIds[errorKey] =
                `${errorKey}-${Math.random().toString(20).substr(2, 5)}`;
        }

        const errorId = this.errorIds[errorKey];

        input.setAttribute('aria-errormessage', errorId);
        input.setAttribute('aria-invalid', true);

        fieldContainer.dispatchEvent(
            new CustomEvent('formie:add-error', {
                detail: { message: errorMessage },
                bubbles: false,
            })
        );

        this.emitEvent(input, 'formieValidatorShowError', {
            validatorName,
            errorMessage,
        });
    }
}

export default FormieValidator;
